export default __webpack_public_path__ + "static/media/placeholder_store05-es-web.7d7bec1f.png";